import { useTranslation } from 'react-i18next';
import { Box, Typography, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import { getPasswordRules } from '@utils/passwordValidation';

/**
 * Composant qui affiche les règles de validation de mot de passe
 * avec des indicateurs visuels (vert pour valide, rouge pour invalide)
 * 
 * @param {Object} props
 * @param {string} props.password - Le mot de passe à valider
 */
function PasswordValidationRules({ password = '' }) {
  const { t } = useTranslation();

  // Obtenir les règles de validation avec leur état
  const passwordRules = getPasswordRules(password);
  
  // Ajouter les labels traduits aux règles
  const rules = [
    {
      ...passwordRules[0],
      label: t('Must contain at least 12 characters'),
    },
    // Règle de longueur maximale masquée pour l'utilisateur
    // mais toujours active dans la validation
    {
      ...passwordRules[2],
      label: t('Must contain at least one lowercase letter'),
    },
    {
      ...passwordRules[3],
      label: t('Must contain at least one uppercase letter'),
    },
    {
      ...passwordRules[4],
      label: t('Must contain at least one number'),
    },
    {
      ...passwordRules[5],
      label: t('Must contain at least one special character'),
    },
  ];

  return (
    <Box sx={{ mt: 1, mb: 2 }}>
      <Typography variant="caption" color="text.secondary" gutterBottom>
        {t('Password requirements:')}
      </Typography>
      <List dense disablePadding>
        {rules.map((rule) => (
          <ListItem key={rule.id} disablePadding>
            <ListItemIcon sx={{ minWidth: 30 }}>
              {rule.valid ? (
                <CheckCircleIcon color="success" fontSize="small" />
              ) : (
                <CancelIcon color="error" fontSize="small" />
              )}
            </ListItemIcon>
            <ListItemText
              primary={
                <Typography
                  variant="caption"
                  color={rule.valid ? 'success.main' : 'text.secondary'}
                >
                  {rule.label}
                </Typography>
              }
            />
          </ListItem>
        ))}
      </List>
    </Box>
  );
}

export default PasswordValidationRules; 